/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useRef } from "react";
import {
  I2cInput,
  I2cMenuItem,
  I2cSelect,
  I2cFileUpload,
  I2cRadioButton,
  I2cRadioGroup,
  I2cCheckboxGroup,
  I2cListItem,
  I2cCheckbox,
  I2cTextarea,
  I2cTooltip,
  I2cIcon,
  I2cButton,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import { validationSchema } from "./validationSchema";
import NewProgamForm from "./NewProgramForm";
import NewMigrationForm from "./NewMigrationForm";
import NewMigrationTypeForm from "../../CreditInstance/ProgramInformation/NewMigrationForm";
import {
  reloadCardProgram,
  programTypePrepaid,
  programTypeDebit,
  commercialPrepaid,
  consumerPrepaid,
  setupType,
  currencies,
  debitOrPrepaid,
  generalEntityType,
} from "./FieldsListingLabels";
import FilesUploadService from "../../../Services/FilesUploadService";
import { useMutation } from "react-query";
import { OverlayLoader } from "../../../Components/Loader/Loader";
export const timeZones = [
  { label: "Pacific Standard Time", value: "Pacific Standard Time" },
  { label: "Eastern Standard Time", value: "Eastern Standard Time" },
  { label: "CST", value: "CST" },
];
const ProgramInfo = ({
  setFormValidStates,
  setAddFormData,
  addFormData,
  activeInnerStep,
  formDataJson,
  isFetching,
}) => {
  // Define validation schema using Yup
  // Initialize React Hook Form with Yup resolver
  const Manual = useRef(null);
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      pi_program_name: "",
      pi_standard_time: "Pacific Standard Time",
      pi_program_debit_or_credit: "prepaid",
      pi_card_program: "reloadable",
      pi_program_type_prepaid: 0,
      pi_program_type_prepaid_other: "",
      pi_system_records_debit: [],
      pi_system_records_debit_other: "",
      pi_auth_transac_debit: [],
      pi_auth_transac_debit_other: "",
      pi_program_type_debit: [],
      pi_program_type_debit_other: "",
      pi_selected_commercial_types: [],
      pi_selected_consumer_types: [],
      pi_commercial_type_other: "",
      pi_consumer_type_other: "",
      pi_proposition_value: "",
      pi_segment_value: "",
      pi_card_program_currency: "",
      pi_setup_type: "new-program",
      pi_type_of_migration: "",
      pi_type_of_processor_name: "",
      pi_ecount_1: "",
      pi_ecount_2: "",
      pi_ecount_3: "",
      pi_ecount_4: "",
      pi_evalue_1: "",
      pi_evalue_2: "",
      pi_evalue_3: "",
      pi_evalue_4: "",
      pi_evolume_1: "",
      pi_evolume_2: "",
      pi_evolume_3: "",
      pi_evolume_4: "",
      pi_current_processor_name: "",
      pi_key_component_custodians: [],
      pi_key_component_custodians_other: "",
      pi_data_migration_attributes: [],
      pi_data_migration_attributes_other: "",
      pi_cpm_compliant: "",
      pi_compliant_certificate: "",
      pi_migration_type: "migration-program",
      pi_mig_np_ecount_1: "",
      pi_mig_np_ecount_2: "",
      pi_mig_np_ecount_3: "",
      pi_mig_np_ecount_4: "",
      pi_mig_np_evalue_1: "",
      pi_mig_np_evalue_2: "",
      pi_mig_np_evalue_3: "",
      pi_mig_np_evalue_4: "",
      pi_mig_np_evolume_1: "",
      pi_mig_np_evolume_2: "",
      pi_mig_np_evolume_3: "",
      pi_mig_np_evolume_4: "",
    },
  });
  const fields = [
    "pi_program_name",
    "pi_standard_time",
    "pi_program_debit_or_credit",
    "pi_card_program",
    "pi_program_type_prepaid",
    "pi_program_type_prepaid_other",
    "pi_system_records_debit_other",
    "pi_auth_transac_debit_other",
    "pi_program_type_debit_other",
    "pi_commercial_type_other",
    "pi_consumer_type_other",
    "pi_proposition_value",
    "pi_segment_value",
    "pi_card_program_currency",
    "pi_setup_type",
    "pi_type_of_migration",
    "pi_type_of_processor_name",
    "pi_ecount_1",
    "pi_ecount_2",
    "pi_ecount_3",
    "pi_ecount_4",
    "pi_evalue_1",
    "pi_evalue_2",
    "pi_evalue_3",
    "pi_evalue_4",
    "pi_evolume_1",
    "pi_evolume_2",
    "pi_evolume_3",
    "pi_evolume_4",
    "pi_current_processor_name",
    "pi_key_component_custodians_other",
    "pi_data_migration_attributes_other",
    "pi_cpm_compliant",
    "pi_compliant_certificate",
    "pi_migration_type",
    "pi_mig_np_ecount_1",
    "pi_mig_np_ecount_2",
    "pi_mig_np_ecount_3",
    "pi_mig_np_ecount_4",
    "pi_mig_np_evalue_1",
    "pi_mig_np_evalue_2",
    "pi_mig_np_evalue_3",
    "pi_mig_np_evalue_4",
    "pi_mig_np_evolume_1",
    "pi_mig_np_evolume_2",
    "pi_mig_np_evolume_3",
    "pi_mig_np_evolume_4",
  ];
  const arrayFields = [
    "pi_auth_transac_debit",
    "pi_data_migration_attributes",
    "pi_key_component_custodians",
    "pi_program_type_debit",
    "pi_selected_commercial_types",
    "pi_selected_consumer_types",
    "pi_system_records_debit",
  ];
  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);
  const formData = new FormData();

  const downloadFile = async (fileName) => {
    try {
      await fileDownload.mutate(fileName);
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fileDownload = useMutation({
    mutationFn: async (fileName) => {
      return await FilesUploadService.downloadFile(fileName);
    },
    onSuccess: (data) => {
      const url = window.URL.createObjectURL(
        new Blob([data.data], { type: "application/pdf" }),
      );
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";

      // Set the download attribute with the file name
      // link.setAttribute('download', fileName);

      // Append to the document and trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    },
    onError: (e) => {
      console.log("api error", e);
    },
  });
  useEffect(() => {

    customElements.whenDefined('i2c-file-upload').then(() => {
      if (Manual.current !== null) {
        const myDropzone = Manual.current.getDropZone();
        const token = localStorage.getItem("token");
        myDropzone.options.url = process.env.REACT_APP_API_BASE_URL + "api/file/upload/pdf";
        myDropzone.options.headers = {
          'X-Requested-With': null,
          'Access-Control-Allow-Headers': null, 'Authorization': 'Bearer ' + token,
        };
      }
    });

  }, [])

  const handleFileUpload = async (name) => {
    try {
      formData.append("file", Manual.current.fileUpload.files[0]);
      await fileUpload.mutate(formData);
    } catch (error) {
      console.log(error);
    } finally {
      methods.trigger();
    }
  };
  const fileUpload = useMutation({
    mutationFn: async (formData) => {
      setFormValidStates("1_0", false);
      return await FilesUploadService.uploadFile(formData);
    },
    onSuccess: (data) => {
      methods.setValue("pi_compliant_certificate", data?.data?.url);
      methods.trigger();

      handleValueChanges();
    },
    onError: (error) => {
      console.log("API error:", error);

      // Handle Laravel validation errors (422) or malicious file errors (404)
      let errorMessage = "An error occurred during file upload.";

      if (error.response?.status === 422) {
        // Validation error: { errors: { files: ["A file is required.", ...] } }
        const errors = error.response?.data?.errors?.files;
        if (errors && Array.isArray(errors)) {
          errorMessage = errors.join(" ");
        }
      } else if (error.response?.status === 404) {
        // Malicious file error: { status: false, error: "This is a bad file..." }
        errorMessage = error.response?.data?.error || errorMessage;
      }

      // Display the error message to the user (e.g., via a toast or form error)
      console.error("Upload error:", errorMessage);
      // Optionally, update the form with the error
      methods.setError("pi_compliant_certificate", { type: "manual", message: errorMessage });
      methods.trigger();
    },
  });
  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      1: {
        ...addFormData["1"],
        "1_0": { ...values },
      },
    });
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("1_0", true);
  };

  useEffect(() => {
    try {
      if (!isFetching && Object.keys(formDataJson ?? {}).length) {
        fields.forEach((field) => {
          methods.setValue(field, formDataJson[1]["1_0"][field] ?? "");
        });
        arrayFields.forEach((field) => {
          methods.setValue(field, formDataJson[1]["1_0"][field] ?? []);
        });
      }
    } finally {
      methods.trigger();
    }
  }, [isFetching]);

  // Update form validation state when errosrs change
  React.useEffect(() => {
    // methods.trigger();
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("1_0", true);
    else setFormValidStates("1_0", false);
  }, [Object.keys(errors).length]);



  const handleCommercialPrepaidChange = (event) => {
    let selectedComValues;
    if (isNaN(event)) selectedComValues = event.target.value;
    else selectedComValues = event;
    const preSelected = methods.getValues("pi_selected_commercial_types") ?? [];
    let updatedComPrepaid = [...preSelected];
    if (updatedComPrepaid.includes(selectedComValues)) {
      updatedComPrepaid = updatedComPrepaid.filter(
        (card) => card !== selectedComValues,
      );
    } else {
      updatedComPrepaid.push(selectedComValues);
    }
    if (!updatedComPrepaid.includes(4)) {
      methods.setValue("pi_commercial_type_other", "");
    }
    methods.setValue("pi_selected_commercial_types", updatedComPrepaid);
    methods.trigger();
    handleValueChanges();
  };
  const handleConsumerPrepaidChange = (event) => {

    let selectedComValues;
    if (isNaN(event)) selectedComValues = event.target.value;
    else selectedComValues = event;
    const preSelected = methods.getValues("pi_selected_consumer_types") ?? [];
    let updatedConsumersPrepaid = [...preSelected];
    if (updatedConsumersPrepaid.includes(selectedComValues)) {
      updatedConsumersPrepaid = updatedConsumersPrepaid.filter(
        (card) => card !== selectedComValues,
      );
    } else {
      updatedConsumersPrepaid.push(selectedComValues);
    }
    if (!updatedConsumersPrepaid.includes(7)) {
      methods.setValue("pi_consumer_type_other", "");
    }

    methods.setValue("pi_selected_consumer_types", updatedConsumersPrepaid);
    methods.trigger();
    handleValueChanges();
  };
  const handleCheckboxGroupChange = (event) => {
    let selectedOptions;
    if (isNaN(event)) selectedOptions = event?.target?.value;
    else selectedOptions = event;
    let updatedSelectedOptions = [
      ...(methods.getValues("pi_program_type_debit") ?? []),
    ];
    if (updatedSelectedOptions.includes(selectedOptions)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== selectedOptions,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(selectedOptions);
    }
    if (!updatedSelectedOptions.includes(2)) {
      methods.setValue("pi_program_type_debit_other", "");
    }
    methods.setValue("pi_program_type_debit", updatedSelectedOptions);
    handleValueChanges();
    methods.trigger();
  };

  const handleCheckboxGroupChangeTransactions = (event) => {
    let selectedOptions;
    if (isNaN(event)) selectedOptions = event?.target?.value;
    else selectedOptions = event;
    let updatedSelectedOptions = [
      ...(methods.getValues("pi_auth_transac_debit") ?? []),
    ];
    if (updatedSelectedOptions.includes(selectedOptions)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== selectedOptions,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(selectedOptions);
    }
    if (!updatedSelectedOptions.includes(1)) {
      methods.setValue("pi_auth_transac_debit_other", "");
    }
    methods.setValue("pi_auth_transac_debit", updatedSelectedOptions);
    handleValueChanges();
    methods.trigger();
  };

  const handleCheckboxGroupChangeSystemRecords = (event) => {
    let selectedOptions;
    if (isNaN(event)) selectedOptions = event?.target?.value;
    else selectedOptions = event;
    let updatedSelectedOptions = [
      ...(methods.getValues("pi_system_records_debit") ?? []),
    ];
    if (updatedSelectedOptions.includes(selectedOptions)) {
      // If the card is already selected, remove it
      updatedSelectedOptions = updatedSelectedOptions.filter(
        (card) => card !== selectedOptions,
      );
    } else {
      // If the card is not selected, add it
      updatedSelectedOptions.push(selectedOptions);
    }
    if (!updatedSelectedOptions.includes(1)) {
      methods.setValue("pi_system_records_debit_other", "");
    }
    methods.setValue("pi_system_records_debit", updatedSelectedOptions);
    methods.trigger();
    handleValueChanges();
  };
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <div slot="label" className="organize-tooltip mb-6">
                <div className="custom-label">
                  Program Name
                </div>
                <I2cTooltip
                  content="Specify the name and URL communicated in the program marketing  material"
                  placement="right-start"
                >
                  <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
                </I2cTooltip>
              </div>
              <Controller
                name="pi_program_name"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cInput
                      {...field}
                      className="single-input-field"
                      placeholder="Enter Program Name"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      size="large"
                      name={"pi_program_name"}
                    ></I2cInput>
                  </>
                )}
              />
            </div>
          </div>
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
              <div slot="label" className="organize-tooltip mb-6">
                <div className="custom-label">
                  Instance Time Zone for Reporting  
                </div>
                <I2cTooltip
                  content="Instance time zone cannot be changed once set"
                  placement="right-start"
                  hoist
                >
                  <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
                </I2cTooltip>
              </div>

              <Controller
                name="pi_standard_time"
                control={control}
                render={({ field }) => (
                  <I2cSelect
                    {...field}
                    name="pi_standard_time"
                    onI2cChange={(e) => {
                      methods.setValue("pi_standard_time", e.target.value);
                      handleValueChanges();
                    }}
                    value={methods.watch("pi_standard_time")}
                    placeholder="Select Time Zone"
                    size="large"
                  >
                    {timeZones.map((zone, index) => (
                      <I2cMenuItem key={index} value={zone.value}>
                        {zone.label}
                      </I2cMenuItem>
                    ))}
                  </I2cSelect>
                )}
              />
              <ErrorMessage
                show={
                  errors.pi_standard_time &&
                    methods.formState.touchedFields.pi_standard_time
                    ? true
                    : false
                }
                message={errors.pi_standard_time?.message ?? "Invalid input"}
              />
            </div>
          </div>
        </div>

        <div className="section-space">
          <div className="organize-tooltip mb-16">
            <div className="sub-heading">
              Will the program be Debit or Prepaid  
            </div>
          </div>
          <div className="single-field-wrapper ">
            <Controller
              name="pi_program_debit_or_credit"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  value={methods.watch("pi_program_debit_or_credit")}
                  {...field}
                  name="pi_program_debit_or_credit"
                >
                  {debitOrPrepaid.map((cp, index) => (
                    <I2cRadioButton
                      key={index}
                      onClick={(e) => {
                        if (e.target.value === "prepaid") {
                          methods.setValue("pi_system_records_debit", []);
                          methods.setValue("pi_system_records_debit_other", "");
                          methods.setValue("pi_auth_transac_debit", []);
                          methods.setValue("pi_auth_transac_debit_other", "");
                          methods.setValue("pi_program_type_debit", []);
                          methods.setValue("pi_program_type_debit_other", "");
                        } else if (e.target.value === "debit") {
                          methods.setValue("pi_card_program", "");
                          methods.setValue("pi_program_type_prepaid", 0);
                          methods.setValue("pi_selected_commercial_types", []);
                          methods.setValue("pi_commercial_type_other", "");
                          methods.setValue("pi_selected_consumer_types", []);
                          methods.setValue("pi_consumer_type_other", "");
                        }
                        else{
                          methods.setValue("pi_system_records_debit", []);
                          methods.setValue("pi_system_records_debit_other", "");
                          methods.setValue("pi_auth_transac_debit", []);
                          methods.setValue("pi_auth_transac_debit_other", "");
                          methods.setValue("pi_program_type_debit", []);
                          methods.setValue("pi_program_type_debit_other", "");
                          methods.setValue("pi_card_program", "");
                          methods.setValue("pi_program_type_prepaid", 0);
                          methods.setValue("pi_selected_commercial_types", []);
                          methods.setValue("pi_commercial_type_other", "");
                          methods.setValue("pi_selected_consumer_types", []);
                          methods.setValue("pi_consumer_type_other", "");
                        }
                        field.onChange(e);
                        methods.trigger();
                        handleValueChanges();
                      }}
                      value={cp.toLocaleLowerCase()}
                    >
                      {cp}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.pi_program_debit_or_credit &&
                  methods.formState.touchedFields.pi_program_debit_or_credit
                  ? true
                  : false
              }
              message={
                errors.pi_program_debit_or_credit?.message ?? "Invalid input"
              }
            />
          </div>
        </div>

        {methods.watch("pi_program_debit_or_credit") === "prepaid" && (
          <div className="section-space">
            <div className="organize-tooltip mb-16">
              <div className="sub-heading">
                Reloadable or Non-Reloadable Card Program  
              </div>
              <I2cTooltip
                content="A reloadable card can have funds loaded to it after the initial
                funding load. Non-Reloadable cards can only be used once. KYC
                procedures might have to be completed according to the local laws
                and regulations for reloadable cards."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
              </I2cTooltip>
            </div>
            <div className="single-field-wrapper ">
              <Controller
                name="pi_card_program"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("pi_card_program")}
                    {...field}
                    name="pi_card_program"
                  >
                    {reloadCardProgram.map((cp, index) => (
                      <I2cRadioButton
                        key={index}
                        onClick={(e) => {
                          field.onChange(e);
                          handleValueChanges();
                        }}
                        value={cp.toLocaleLowerCase()}
                      >
                        {cp}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              <ErrorMessage
                show={
                  errors.pi_card_program &&
                    methods.formState.touchedFields.pi_card_program
                    ? true
                    : false
                }
                message={errors.pi_card_program?.message ?? "Invalid input"}
              />
            </div>
          </div>
        )
        }
        {methods.watch("pi_program_debit_or_credit") === "debit" && (
          <>
            <div className="section-space">
              <span slot="label" className="organize-tooltip mb-16">
                <div className="sub-heading">
                  Who would be the system of records?  
                </div>
              </span>
              <div className="single-field-wrapper">
                <Controller
                  name="pi_system_records_debit"
                  control={control}
                  render={({ field }) => (
                    <>
                      <I2cCheckboxGroup {...field}>
                        <div i2c-grid="grid gap-sm">
                          {generalEntityType.map((app, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="6@md"
                              variant="receipt"
                              label={app.label}
                              sublabel=""
                              value=""
                              checked={methods
                                .watch("pi_system_records_debit")
                                .includes(app.value)}
                              onI2cCheckboxClicked={(e) => {
                                handleCheckboxGroupChangeSystemRecords(
                                  app.value,
                                );
                              }}
                              type="checkbox"
                            >
                              <I2cCheckbox
                                slot="prefix"
                                value={app.value}
                                label=""
                                filled
                                checked={methods
                                  .watch("pi_system_records_debit")
                                  .includes(app.value)}
                                className="customCheckbox"

                              ></I2cCheckbox>
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cCheckboxGroup>
                      <ErrorMessage
                        show={
                          errors.pi_system_records_debit &&
                            methods.formState.touchedFields
                              .pi_system_records_debit
                            ? true
                            : false
                        }
                        message={
                          errors.pi_system_records_debit?.message ??
                          "Invalid input"
                        }
                      />
                    </>
                  )}
                />
              </div>
              {methods.watch("pi_system_records_debit")?.includes(1) &&
                methods.watch("pi_program_debit_or_credit") === "debit" && (
                  <div
                    key={"pi_system_records_debit-2"}
                    className="mt-16 halfWidth"
                  >
                    <div className="single-field-wrapper">
                      <Controller
                        name="pi_system_records_debit_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Other Details"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                            label="Enter Details"
                            name={"pi_system_records_debit_other"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pi_system_records_debit_other &&
                          methods.formState.touchedFields
                            .pi_system_records_debit_other
                            ? true
                            : false
                        }
                        message={
                          errors.pi_system_records_debit_other?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                )}
            </div>
            <div className="section-space">
              <span slot="label" className="organize-tooltip mb-16">
                <div className="sub-heading">
                  Who would be authorizing the transactions?  
                </div>
              </span>
              <div className="single-field-wrapper">
                <Controller
                  name="pi_auth_transac_debit"
                  control={control}
                  render={({ field }) => (
                    <>
                      <I2cCheckboxGroup
                        {...field}
                      // onI2cChange={(e) => handleCheckboxGroupChange(e)}
                      >
                        <div i2c-grid="grid gap-sm">
                          {generalEntityType.map((app, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="6@md"
                              variant="receipt"
                              label={app.label}
                              sublabel=""
                              value=""
                              checked={methods
                                .watch("pi_auth_transac_debit")
                                .includes(app.value)}
                              onI2cCheckboxClicked={(e) => {
                                handleCheckboxGroupChangeTransactions(
                                  app.value,
                                );
                              }}
                              type="checkbox"
                            >
                              <I2cCheckbox
                                slot="prefix"
                                value={app.value}
                                label=""
                                filled
                                checked={methods
                                  .watch("pi_auth_transac_debit")
                                  .includes(app.value)}
                                className="customCheckbox"

                              ></I2cCheckbox>
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cCheckboxGroup>
                      <ErrorMessage
                        show={
                          errors.pi_auth_transac_debit &&
                            methods.formState.touchedFields.pi_auth_transac_debit
                            ? true
                            : false
                        }
                        message={
                          errors.pi_auth_transac_debit?.message ??
                          "Invalid input"
                        }
                      />
                    </>
                  )}
                />
              </div>
              {methods.watch("pi_auth_transac_debit")?.includes(1) &&
                methods.watch("pi_program_debit_or_credit") === "debit" && (
                  <div
                    key={"pi_auth_transac_debit_other-2"}
                    className="mt-16 halfWidth"
                  >
                    <div className="single-field-wrapper">
                      <Controller
                        name="pi_auth_transac_debit_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Other Details"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                            label="Enter Details"
                            name={"pi_auth_transac_debit_other"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pi_auth_transac_debit_other &&
                          methods.formState.touchedFields
                            .pi_auth_transac_debit_other
                            ? true
                            : false
                        }
                        message={
                          errors.pi_auth_transac_debit_other?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                )}
            </div>
          </>
        )}
        <div className="section-space">
          {methods.watch("pi_program_debit_or_credit") !== "n/a" && (
            <span slot="label" className="organize-tooltip mb-16">
              <div className="sub-heading">
                Program Type  
              </div>
              <I2cTooltip
                content="The category selected here should coincide with the Program Type
     you have applied for (or received an approval for) from the
     Payment Network. If you plan to launch a Credit or a Debit
     program, please ask your project manager to provide you the
     relevant CSD."
                placement="right-start"
              >
                <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
              </I2cTooltip>
            </span>
          ) 
          }

          {methods.watch("pi_program_debit_or_credit") === "prepaid" && (
            <div className="single-field-wrapper">
              <Controller
                name="pi_program_type_prepaid"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    {...field}
                    value={methods.watch("pi_program_type_prepaid")}
                    name="pi_program_type_prepaid"
                  >
                    {programTypePrepaid.map((cp, index) => (
                      <I2cRadioButton
                        key={index}
                        onClick={(e) => {
                          if (e.target.value === 0) {
                            // Consumer selected - clear commercial and other fields
                            methods.setValue(
                              "pi_selected_commercial_types",
                              [],
                            );
                            methods.setValue("pi_commercial_type_other", "");
                            methods.setValue("pi_program_type_prepaid_other", "");
                          } else if (e.target.value === 2) {
                            // Other selected - clear commercial and consumer fields
                            methods.setValue("pi_selected_commercial_types", []);
                            methods.setValue("pi_commercial_type_other", "");
                            methods.setValue("pi_selected_consumer_types", []);
                            methods.setValue("pi_consumer_type_other", "");
                          } else {
                            // Commercial selected - clear consumer and other fields
                            methods.setValue("pi_selected_consumer_types", []);
                            methods.setValue("pi_consumer_type_other", "");
                            methods.setValue("pi_program_type_prepaid_other", "");
                          }
                          field.onChange(e);
                          handleValueChanges();
                          methods.trigger();
                        }}
                        value={cp.value}
                      >
                        {cp.label}
                      </I2cRadioButton>
                    ))}
                  </I2cRadioGroup>
                )}
              />
              {methods.watch("pi_program_type_prepaid") === 2 && (
                <div
                  key={"pi_program_type_prepaid-other"}
                  className="mt-16 halfWidth"
                >
                  <div className="single-field-wrapper">
                    <Controller
                      name="pi_program_type_prepaid_other"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          placeholder="Other Details"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Enter Details"
                          name={"pi_program_type_prepaid_other"}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
              <ErrorMessage
                show={
                  errors.pi_program_type_prepaid &&
                    methods.formState.touchedFields.pi_program_type_prepaid
                    ? true
                    : false
                }
                message={
                  errors.pi_program_type_prepaid?.message ?? "Invalid input"
                }
              />
            </div>
          )}

          {methods.watch("pi_program_debit_or_credit") === "debit" && (
            <div className="single-field-wrapper">
              <Controller
                name="pi_program_type_debit"
                control={control}
                render={({ field }) => (
                  <>
                    <I2cCheckboxGroup
                      {...field}
                    >
                      <div i2c-grid="grid gap-sm">
                        {programTypeDebit.map((app, index) => (
                          <I2cListItem
                            key={index}
                            i2c-grid="4@md"
                            variant="receipt"
                            label={app.label}
                            sublabel=""
                            value=""
                            checked={methods
                              .watch("pi_program_type_debit")
                              .includes(app.value)}
                            onI2cCheckboxClicked={(e) => {
                              handleCheckboxGroupChange(app.value);
                            }}
                            type="checkbox"
                          >
                            <I2cCheckbox
                              slot="prefix"
                              value={app.value}
                              label=""
                              filled
                              checked={methods
                                .watch("pi_program_type_debit")
                                .includes(app.value)}
                              className="customCheckbox"

                            ></I2cCheckbox>
                          </I2cListItem>
                        ))}
                      </div>

                    </I2cCheckboxGroup>
                    <ErrorMessage
                      show={
                        errors.pi_program_type_debit &&
                          methods.formState.touchedFields.pi_program_type_debit
                          ? true
                          : false
                      }
                      message={
                        errors.pi_program_type_debit?.message ?? "Invalid input"
                      }
                    />
                  </>
                )}
              />
            </div>
          )}
          {methods.watch("pi_program_type_debit")?.includes(2) &&
            methods.watch("pi_program_debit_or_credit") === "debit" && (
              <div
                key={"pi_program_type_prepaid-2"}
                className="mt-16 halfWidth"
              >
                <div className="single-field-wrapper">
                  <Controller
                    name="pi_program_type_debit_other"
                    control={control}
                    render={({ field }) => (
                      <I2cInput
                        {...field}
                        className="single-input-field"
                        placeholder="Other Details"
                        onI2cInput={(e) => {
                          const value = e.target.value;
                          field.onChange(value);
                          handleValueChanges();
                        }}
                        size="large"
                        label="Enter Details"
                        name={"pi_program_type_debit_other"}
                      />
                    )}
                  />
                  {/* <ErrorMessage
                    show={
                      errors.pi_program_type_debit_other &&
                      methods.formState.touchedFields
                        .pi_program_type_debit_other
                        ? true
                        : false
                    }
                    message={
                      errors.pi_program_type_debit_other?.message ??
                      "Invalid input"
                    }
                  /> */}
                </div>
              </div>
            )}
          {methods.watch("pi_program_type_prepaid") === 0 &&
            methods.watch("pi_program_debit_or_credit") === "prepaid" && (
              <div className="mt-16">
                <div className="single-field-wrapper">
                  <Controller
                    name="pi_selected_consumer_types"
                    control={control}
                    render={({ field }) => (
                      <I2cCheckboxGroup {...field}
                      >
                        <div i2c-grid="grid gap-sm">
                          {consumerPrepaid.map((app, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="4@md"
                              variant="receipt"
                              label={app.label}
                              sublabel=""
                              value=""
                              type="checkbox"
                              checked={methods
                                .watch("pi_selected_consumer_types")
                                .includes(app.value)}
                              onI2cCheckboxClicked={(e) =>
                                handleConsumerPrepaidChange(app.value)
                              }
                            >
                              <I2cCheckbox
                                slot="prefix"
                                value={app.value}
                                label=""
                                ignoreTab
                                filled
                                checked={methods
                                  .watch("pi_selected_consumer_types")
                                  .includes(app.value)}
                                className='customCheckbox'


                              ></I2cCheckbox>
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cCheckboxGroup>
                    )}
                  />
                </div>
                <ErrorMessage
                  show={
                    errors.pi_selected_consumer_types &&
                    methods.formState.touchedFields.pi_selected_consumer_types
                  }
                  message={
                    errors.pi_selected_consumer_types?.message ??
                    "Invalid input"
                  }
                />
                {methods.watch("pi_selected_consumer_types").includes(7) && (
                  <div key={4} className="mt-16 halfWidth">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pi_consumer_type_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Other Details"
                            
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                            label="Enter Details"
                            name={"pi_consumer_type_other"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pi_consumer_type_other &&
                          methods.formState.touchedFields.pi_consumer_type_other
                            ? true
                            : false
                        }
                        message={
                          errors.pi_consumer_type_other?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                )}
              </div>
            )}

          {methods.watch("pi_program_type_prepaid") === 1 &&
            methods.watch("pi_program_debit_or_credit") === "prepaid" && (
              <div className="mt-16">
                <div className="single-field-wrapper">
                  <Controller
                    name="pi_selected_commercial_types"
                    control={control}
                    render={({ field }) => (
                      <I2cCheckboxGroup {...field}>
                        <div i2c-grid="grid gap-sm">
                          {commercialPrepaid.map((app, index) => (
                            <I2cListItem
                              key={index}
                              i2c-grid="4@md"
                              variant="receipt"
                              label={app.label}
                              sublabel=""
                              value=""
                              checked={methods
                                .watch("pi_selected_commercial_types")
                                ?.includes(app.value)}
                              onI2cCheckboxClicked={(e) =>
                                handleCommercialPrepaidChange(app.value)
                              }
                              type="checkbox"
                            >
                              <I2cCheckbox
                                slot="prefix"
                                value={app.value}
                                label=""
                                ignoreTab
                                filled
                                checked={methods
                                  .watch("pi_selected_commercial_types")
                                  ?.includes(app.value)}
                                className='customCheckbox'

                              ></I2cCheckbox>
                            </I2cListItem>
                          ))}
                        </div>
                      </I2cCheckboxGroup>
                    )}
                  />
                </div>
                <ErrorMessage
                  show={
                    errors.pi_selected_commercial_types &&
                    methods.formState.touchedFields.pi_selected_commercial_types
                  }
                  message={
                    errors.pi_selected_commercial_types?.message ??
                    "Invalid input"
                  }
                />
                {methods.watch("pi_selected_commercial_types").includes(4) && (
                  <div key={4} className="mt-16 halfWidth">
                    <div className="single-field-wrapper">
                      <Controller
                        name="pi_commercial_type_other"
                        control={control}
                        render={({ field }) => (
                          <I2cInput
                            {...field}
                            className="single-input-field"
                            placeholder="Please Specify"
                            onI2cInput={(e) => {
                              const value = e.target.value;
                              field.onChange(value);
                              handleValueChanges();
                            }}
                            size="large"
                            label="Please Specify"
                            name={"pi_commercial_type_other"}
                          />
                        )}
                      />
                      {/* <ErrorMessage
                        show={
                          errors.pi_commercial_type_other &&
                          methods.formState.touchedFields
                            .pi_commercial_type_other
                            ? true
                            : false
                        }
                        message={
                          errors.pi_commercial_type_other?.message ??
                          "Invalid input"
                        }
                      /> */}
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>
        <div className="section-space">
          <span slot="label" className="organize-tooltip mb-16">
            <div className="sub-heading">
              Program Description  
            </div>
            <I2cTooltip
              content="Enter a brief description here to help i2c team understand the
                business case."
              placement="right-start"
            >
              <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
            </I2cTooltip>
          </span>
          <div i2c-grid="grid gap-sm">
            <div i2c-grid="12@md 6@lg">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_proposition_value"
                  control={control}
                  render={({ field }) => (
                    <I2cTextarea
                      {...field}
                      name="pi_proposition_value"
                      resize="none"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      invalid={errors.pi_proposition_value}
                      placeholder="Enter Details"
                      label="What is the value proposition, how is the program different
                      form other options in the market?"
                      className="label-margin"
                      rows={2}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_proposition_value &&
                      methods.formState.touchedFields.pi_proposition_value
                      ? true
                      : false
                  }
                  message={
                    errors.pi_proposition_value?.message ?? "Invalid input"
                  }
                />
              </div>
            </div>
            <div i2c-grid="12@md 6@lg">
              <div className="single-field-wrapper">
                <Controller
                  name="pi_segment_value"
                  control={control}
                  render={({ field }) => (
                    <I2cTextarea
                      {...field}
                      name="pi_segment_value"
                      resize="none"
                      onI2cInput={(e) => {
                        const value = e.target.value;
                        field.onChange(value);
                        handleValueChanges();
                      }}
                      invalid={errors.pi_segment_value}
                      placeholder="Enter Details"
                      label="Which segment of the market is this program going to be
                      targeted towards?"
                      className="label-margin"
                      rows={2}
                    />
                  )}
                />
                <ErrorMessage
                  show={
                    errors.pi_segment_value &&
                      methods.formState.touchedFields.pi_segment_value
                      ? true
                      : false
                  }
                  message={errors.pi_segment_value?.message ?? "Invalid input"}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="section-space">
          <span slot="label" className="organize-tooltip mb-4">
            <div className="sub-heading">
              Card Program Currency  
            </div>
            <I2cTooltip
              content="If you have specified multiple currencies, please confirm the base currency"
              placement="right-start"
            >
              <I2cIcon label="placement" name="cs-linear-info" color="#6B7080"></I2cIcon>
            </I2cTooltip>
          </span>
          <div className="custom-label-light mb-16">
            Please confirm the currencies in which the cardholder balances will be maintained
          </div>
          <div i2c-grid="grid gap-sm">
          <div i2c-grid="4@md">
            <div className="single-field-wrapper">
            <Controller
              name="pi_card_program_currency"
              control={control}
              render={({ field }) => (
                <I2cSelect
                  size="large"
                  {...field}
                  placeholder="Specify the program currency"
                  name="pi_card_program_currency"
                  onI2cChange={(e) => {
                    methods.setValue(
                      "pi_card_program_currency",
                      e.target.value,
                    );
                    handleValueChanges();
                  }}
                  value={methods.watch("pi_card_program_currency")}
                >
                  {currencies.map((currency, index) => (
                    <I2cMenuItem key={index + currency} value={currency}>
                      {currency}
                    </I2cMenuItem>
                  ))}
                </I2cSelect>
              )}
            />
            <ErrorMessage
              show={
                errors.pi_card_program_currency &&
                  methods.formState.touchedFields.pi_card_program_currency
                  ? true
                  : false
              }
              message={
                errors.pi_card_program_currency?.message ?? "Invalid input"
              }
            />
            </div>
          </div>
          </div>
        </div>
        <div className="section-space">
          <div className="sub-heading mb-4">Setup Type</div>
          <div className="custom-label-light mb-16">
            Specify the setup type.
          </div>
          <div className="single-field-wrapper">
            <Controller
              name="pi_setup_type"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  {...field}
                  value={methods.watch("pi_setup_type")}
                  name="pi_setup_type"
                  onI2cChange={(e) => {
                    const value = e.target.value ?? "";
                    if (value === "new-program") {
                      methods.setValue("pi_mig_np_ecount_1", "");
                      methods.setValue("pi_mig_np_ecount_2", "");
                      methods.setValue("pi_mig_np_ecount_3", "");
                      methods.setValue("pi_mig_np_ecount_4", "");
                      methods.setValue("pi_mig_np_evalue_1", "");
                      methods.setValue("pi_mig_np_evalue_2", "");
                      methods.setValue("pi_mig_np_evalue_3", "");
                      methods.setValue("pi_mig_np_evalue_4", "");
                      methods.setValue("pi_mig_np_evolume_1", "");
                      methods.setValue("pi_mig_np_evolume_2", "");
                      methods.setValue("pi_mig_np_evolume_3", "");
                      methods.setValue("pi_mig_np_evolume_4", "");
                    }
                    else {
                      methods.setValue("pi_mig_np_ecount_1", "");
                      methods.setValue("pi_mig_np_ecount_2", "");
                      methods.setValue("pi_mig_np_ecount_3", "");
                      methods.setValue("pi_mig_np_ecount_4", "");
                      methods.setValue("pi_mig_np_evalue_1", "");
                      methods.setValue("pi_mig_np_evalue_2", "");
                      methods.setValue("pi_mig_np_evalue_3", "");
                      methods.setValue("pi_mig_np_evalue_4", "");
                      methods.setValue("pi_mig_np_evolume_1", "");
                      methods.setValue("pi_mig_np_evolume_2", "");
                      methods.setValue("pi_mig_np_evolume_3", "");
                      methods.setValue("pi_mig_np_evolume_4", "");
                      methods.setValue("pi_current_processor_name", "");
                      methods.setValue("pi_migration_type", "");
                      methods.setValue("pi_key_component_custodians", []);
                      methods.setValue("pi_key_component_custodians_other", "");
                      methods.setValue("pi_data_migration_attributes", []);
                      methods.setValue("pi_data_migration_attributes_other", "");
                      methods.setValue("pi_type_of_migration", "");
                      methods.setValue("pi_type_of_processor_name", "");
                      methods.setValue("pi_ecount_1", "");
                      methods.setValue("pi_ecount_2", "");
                      methods.setValue("pi_ecount_3", "");
                      methods.setValue("pi_ecount_4", "");
                      methods.setValue("pi_evalue_1", "");
                      methods.setValue("pi_evalue_2", "");
                      methods.setValue("pi_evalue_3", "");
                      methods.setValue("pi_evalue_4", "");
                      methods.setValue("pi_evolume_1", "");
                      methods.setValue("pi_evolume_2", "");
                      methods.setValue("pi_evolume_3", "");
                      methods.setValue("pi_evolume_4", "");
                    }
                    field.onChange(e);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {setupType.map((cp, index) => (
                    <I2cRadioButton
                      key={index}
                      name="pi_setupType"
                      value={cp.toLocaleLowerCase().replace(" ", "-")}
                    >
                      {cp}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.pi_setup_type &&
                  methods.formState.touchedFields.pi_setup_type
                  ? true
                  : false
              }
              message={errors.pi_setup_type?.message ?? "Invalid input"}
            />
          </div>
          {methods.getValues("pi_setup_type") === "migration" && (
            <div className="mt-16 mb-16">
              <NewMigrationTypeForm
                control={control}
                handleValueChanges={handleValueChanges}
                methods={methods}
                errors={errors}
              />
            </div>
          )}
        </div>
        <div>
          {methods.getValues("pi_setup_type") === "new-program" && (
            <NewProgamForm
              control={control}
              handleValueChanges={handleValueChanges}
              methods={methods}
              errors={errors}
            />
          )}
          {methods.getValues("pi_setup_type") === "migration" && (
            <NewMigrationForm
              control={control}
              handleValueChanges={handleValueChanges}
              methods={methods}
              errors={errors}
            />
          )}
        </div>

        <div className="mb-16">
          <div className="sub-heading mb-16">
            Card Program Manager - PCI Compliant
          </div>
          <div className="single-field-wrapper">
            <Controller
              name="pi_cpm_compliant"
              control={control}
              render={({ field }) => (
                <I2cRadioGroup
                  {...field}
                  value={methods.watch("pi_cpm_compliant")}
                  name="pi_cpm_compliant"
                  onI2cChange={(e) => {
                    const value = e.target.value ?? "";
                    if (value === "no")
                      methods.setValue("pi_compliant_certificate", "");
                    field.onChange(e);
                    methods.trigger();
                    handleValueChanges();
                  }}
                >
                  {["Yes", "No", "N/A"].map((cp, index) => (
                    <I2cRadioButton
                      key={index}
                      name="pi_cpm_compliant"
                      value={cp.toLocaleLowerCase().replace(" ", "-")}
                    >
                      {cp}
                    </I2cRadioButton>
                  ))}
                </I2cRadioGroup>
              )}
            />
            <ErrorMessage
              show={
                errors.pi_cpm_compliant &&
                  methods.formState.touchedFields.pi_cpm_compliant
                  ? true
                  : false
              }
              message={errors.pi_cpm_compliant?.message ?? "Invalid input"}
            />
          </div>
        </div>
        <div>
          {methods.watch("pi_cpm_compliant") === "yes" && (
            <>
              <div>
                <div className="custom-label-light mb-16">
                  Provide certificate, if applicable
                </div>

                <I2cFileUpload
                  ref={Manual}
                  autoProcessQueue={false}
                  no-mobile-controls
                  max-files={1}
                  className="customFileUpload"
                  setAcceptedFiles=".pdf"
                  icon="linear-document-upload"
                  label="Click to upload"
                  caption="or drag and drop"
                  name="pi_compliant_certificate"
                  message="Only PDF file (max. 5MB)."
                  onI2cFileRemoved={(e) => {
                    if (
                      formDataJson[0]["0_0"]?.pi_compliant_certificate?.length
                    )
                      methods.setValue(
                        "pi_compliant_certificate",
                        formDataJson[0]["0_0"]?.pi_compliant_certificate,
                      );
                    else methods.setValue("pi_compliant_certificate", "");
                    methods.trigger();
                    handleValueChanges();
                  }}
                  onI2cAddedFile={(e) => {
                    console.log("this is file", e);
                    console.log("this is file manual", Manual.current.getDropZone().files[
                      Manual.current.getDropZone().files.length - 1
                    ]);
                    handleFileUpload(
                      Manual.current.getDropZone().files[
                      Manual.current.getDropZone().files.length - 1
                      ],
                    );
                  }}
                />
              </div>
              {Object.keys(formDataJson ?? {}).length ? (
                <>
                  {formDataJson[0]["0_0"]?.pi_compliant_certificate !== null &&
                    methods.watch("pi_compliant_certificate") ===
                    formDataJson[0]["0_0"]?.pi_compliant_certificate && (
                      <div className="mt-16">
                        <I2cButton
                          size="small"
                          variant="link color"
                          className=""
                          onClick={() => {
                            downloadFile(
                              formDataJson[0]["0_0"]?.pi_compliant_certificate,
                            );
                          }}
                        >
                          <I2cIcon
                            slot="prefix"
                            name="linear-document-download"
                            label="add"
                          ></I2cIcon>{" "}
                          Download File
                        </I2cButton>
                      </div>
                    )}
                </>
              ) : null}
            </>
          )}
        </div>
        {fileUpload.isLoading && <OverlayLoader />}
      </div>
    </React.Fragment>
  );
};

export default ProgramInfo;
